// extracted by mini-css-extract-plugin
export default {"myModal":"MyModal_myModal__AvrXE","myModalContent":"MyModal_myModalContent__+Kr8R","active":"MyModal_active__+THo2"};